import { AvatarImage } from '@/components/ui/avatar';
import { useSignedUrl } from '@/hooks/useSignedUrl';

/**
 * AvatarImage wrapper that resolves signed URLs for private storage buckets.
 * Drop-in replacement for <AvatarImage> when the src is a storage URL.
 */
export function SignedAvatarImage({
    src,
    alt,
}: {
    src: string | null | undefined;
    alt?: string;
}) {
    const signedUrl = useSignedUrl(src);
    if (!signedUrl) return null;
    return <AvatarImage src={signedUrl} alt={alt} />;
}
